var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vue-p5',{staticClass:"p5",on:{"setup":_vm.setup,"draw":_vm.draw,"mouseclicked":_vm.mouseclicked}})}
var staticRenderFns = []

export { render, staticRenderFns }